exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "a[data-v-2e6ca393]{color:inherit;text-decoration:none;cursor:pointer!important;pointer-events:all;-webkit-user-select:none;user-select:none;-webkit-touch-callout:none}p[data-v-2e6ca393]{margin-bottom:12px}ol[data-v-2e6ca393]{list-style:inside}.tocIndex[data-v-2e6ca393]{display:inline-block;font-family:ABCMonumentGrotesk;font-size:20px;font-weight:500;line-height:24px;-webkit-tap-highlight-color:transparent;-webkit-user-select:none;user-select:none;-webkit-touch-callout:none;cursor:pointer;pointer-events:all;margin-bottom:15px;display:flex}.tocIndex[data-v-2e6ca393]:hover{color:#0048ff}.tocIndex-number[data-v-2e6ca393]{display:inline-block;float:left;margin-right:15px}.tocIndex[data-v-2e6ca393]:last-child{margin-bottom:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?minimize!../node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2e6ca393","scoped":true,"hasInlineConfig":false}!../node_modules/sass-loader/lib/loader.js?indentedSyntax!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./components/blocks/TocIndex.vue
// module id = 451
// module chunks = 0